import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export enum DisplayTasksFilter {
  TODAY = 'TODAY',
  PAST_DUE = 'PAST_DUE',
  NO_DUE_DATE = 'NO_DUE_DATE',
  ALL = 'ALL',
}

export interface Preferences {
  isDailyMailEnabled: boolean;
  showCompletedTasks: boolean;
  displayListOfTasksInStatus: DisplayTasksFilter;
  displayAllTeamMemberTasks: boolean;
}

export const PREFERENCES_UPDATED = 'PREFERENCES_UPDATED';

export function usePreferencesService() {
  const backendApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  const savePreferences = async (preferences: Preferences): Promise<Preferences> => {
    const response = await backendApi.post('/preferences', preferences) as Preferences;
    eventsPublisher.publish(PREFERENCES_UPDATED, {});
    return response;
  };

  return {
    savePreferences,
  };
}
